import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './hero9.css'

const Hero9 = (props) => {
  return (
    <div
      id="9"
      className={`hero9-header30 thq-section-padding ${props.rootClassName} `}
    >
      <img
        alt="image"
        sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
        src="/fitnes3-1500h.webp"
        srcSet="/fitnes3-1500h.webp 1200w, /fitnes3-tablet.webp 800w, /fitnes3-mobile.webp 480w"
        className="hero9-image"
      />
      <div className="hero9-container"></div>
      <div className="hero9-max-width thq-section-max-width">
        <div className="hero9-content">
          <h2 className="hero9-text10 thq-heading-1">
            {props.heading1 ?? (
              <Fragment>
                <span className="hero9-text13">Koncept</span>
              </Fragment>
            )}
          </h2>
          <p className="hero9-text11 thq-body-large">
            {props.content1 ?? (
              <Fragment>
                <span className="hero9-text14">
                  <span className="hero9-text15">Moderní</span>
                  <span>
                    {' '}
                    posilovací a cardio stroje značek Matrix a Vision od firmy
                    Johnson Health Tech.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Adaptéry, kotoučová závaží a další doplňkové vybavení značek
                    LMX a Crossmaxx od firmy
                  </span>
                  <br></br>
                  <span className="hero9-text21">Lifemaxx</span>
                  <span>.</span>
                  <br></br>
                  <br></br>
                  <span>
                    Při výběru strojů jsme brali ohled na
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text26">muže</span>
                  <span className="hero9-text27">
                    {' '}
                    i
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text28">ženy</span>
                  <span>
                    , začátečníky i zkušené sportovce, stejně tak na ty, kteří
                    se vracejí ke cvičení po pauze nebo zranění.
                  </span>
                  <br></br>
                  <br></br>
                  <span className="hero9-text32">Diagnostická</span>
                  <span>
                    {' '}
                    tělesná
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text34">váha</span>
                  <span>
                    {' '}
                    značky Tanita, která Vám dodá vhled do Vašeho zdraví pomocí
                    bioelektrické impendance a inovativních technologických
                    poznatků.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    3 silné klimatizační jednotky, které zajistí
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text39">komfortní</span>
                  <span>
                    {' '}
                    teplotu jak při plné kapacitě, tak v extrémních tropických
                    dnech.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Naše fitness funguje na
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text44">čipy</span>
                  <span>
                    , což zajišťuje pohodlný a rychlý přístup, takže po
                    zaregistrování na recepci již žádné zbytečné čekání.
                  </span>
                  <br></br>
                  <br></br>
                  <span className="hero9-text48">Chill zone</span>
                  <span>
                    {' '}
                    vhodná jak pro rekonvalescenci po tréninku, tak pro relaxaci
                    a odpočinek po náročném dni.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Široká nabídka nejenom suplementů, ale i
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text53">smothie</span>
                  <span>
                    , milkshakeů a dokonce mléčných proteinových produktů.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Platit u nás můžete samozřejmě i kartou, benefitníma
                    kartama, nebo depozitem.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text58">Depozit</span>
                  <span>
                    {' '}
                    si můžete dobít pomocí platební brány a získat tak odměnu.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Osobní lekce od našich
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text63">zkušených</span>
                  <span> fitness trenérů a nutričních poradců.</span>
                  <br></br>
                  <br></br>
                  <span>
                    Na co se můžete těšit? V brzké budoucnosti u nás přibude
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="hero9-text68">finská sauna</span>
                  <span>
                    {' '}
                    a další služby, které nám umožní neustále se zlepšovat a
                    poskytovat Vám lepší zážitky.
                  </span>
                  <br></br>
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <a
          href="https://rezervace.fitelite.cz"
          target="_blank"
          rel="noreferrer noopener"
          className="hero9-link thq-button-filled button"
        >
          <span className="hero9-text12 thq-body-large">
            {props.button ?? (
              <Fragment>
                <span className="hero9-text71">Přihlášení a rezervace</span>
              </Fragment>
            )}
          </span>
        </a>
      </div>
    </div>
  )
}

Hero9.defaultProps = {
  heading1: undefined,
  content1: undefined,
  button: undefined,
  rootClassName: '',
}

Hero9.propTypes = {
  heading1: PropTypes.element,
  content1: PropTypes.element,
  button: PropTypes.element,
  rootClassName: PropTypes.string,
}

export default Hero9
